import styled from 'styled-components';
import { rgba, darken } from 'polished';
import Typography from '@material-ui/core/Typography';

// CONSTANTS
import colors, { WHITE, MAIN_BLACK, BLACK, SANTAS_GRAY, RADICAL_RED } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const { appCard } = colors;

export const Section = styled.div`
  max-width: 920px;
  margin: 0 auto;

  .post-header {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    &__title {
      font-weight: 400;
      line-height: 4.2rem;
    }

    &__author {
      display: flex;
      margin: 25px auto 0;

      .author__name {
        color: ${p => p.theme.palette.text.primary};
      }
    }
  }

  .post-share {
    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 40px 0;
    }
  }

  .post-related-posts {
    max-width: 825px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    padding: 80px 0 130px;
    min-height: 330px;
  }
`;

export const WPContent = styled.div`
  padding: 0 0 80px;

  img {
    height: auto;
    max-width: 100%;
    position: relative;

    &.mobile-only {
      display: none;
    }

    ${breakpoints.down('md')} {
      &.desktop-only {
        display: none;
      }
      &.mobile-only {
        display: block;
      }
    }
  }

  figure,
  div {
    &.mobile-only {
      display: none;
    }

    ${breakpoints.down('md')} {
      &.desktop-only {
        display: none;
      }
      &.mobile-only {
        display: block;
      }
    }
  }

  &.regular-mb {
    .hide_on_mb {
      display: none;
    }
  }

  &.partner {
    .hide_on_partner {
      display: none;
    }
  }

  .post-page,
  &.post-page {
    /* !-- WP WYSIWYG Editor Styles -- */
    figure {
      margin: 0;
      text-align: center;
    }

    .entry-content img {
      margin: 0 0 1.5em 0;
    }

    .alignleft,
    img.alignleft {
      margin-right: 1.5em;
      display: inline;
      float: left;
    }

    .alignright,
    img.alignright {
      margin-left: 1.5em;
      display: inline;
      float: right;
    }

    .aligncenter,
    img.aligncenter {
      margin-right: auto;
      margin-left: auto;
      display: block;
      clear: both;
      text-align: center;
    }

    .alignnone,
    img.alignnone {
      /* not sure about this one */
    }

    .wp-caption {
      margin-bottom: 1.5em;
      text-align: center;
      padding-top: 5px;
    }

    .wp-caption img {
      border: 0 none;
      padding: 0;
      margin: 0;
    }

    .wp-caption p.wp-caption-text {
      line-height: 1.5;
      font-size: 10px;
      margin: 0;
    }

    .wp-smiley {
      margin: 0 !important;
      max-height: 1em;
    }

    blockquote.left {
      margin-right: 20px;
      text-align: right;
      margin-left: 0;
      width: 33%;
      float: left;
    }

    blockquote.right {
      margin-left: 20px;
      text-align: left;
      margin-right: 0;
      width: 33%;
      float: right;
    }

    .gallery dl {
    }
    .gallery dt {
    }
    .gallery dd {
    }
    .gallery dl a {
    }
    .gallery dl img {
    }
    .gallery-caption {
    }

    .size-full {
    }
    .size-large {
    }
    .size-medium {
    }
    .size-thumbnail {
    }

    .mb-shortcode {
      .button {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 1;
        padding: 11px 34px;
        border-radius: 20px;
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        cursor: pointer;
        text-align: center;
        white-space: nowrap;
        transition: all 0.2s ease-in-out;
        font-weight: 600;
        width: 160px;
        color: ${p => p.theme.palette.primary.main};
        background-color: transparent;
        border: 2px solid ${p => p.theme.palette.primary.main};

        &:hover {
          color: ${p => p.theme.palette.primary.contrastText};
          background-color: ${p => p.theme.palette.primary.main};
        }
      }

      .service-card {
        position: relative;
        padding: 16px 8px;
        border-radius: 4px;
        background-color: ${WHITE};
        transition: all 0.4s;
        box-shadow: 4px 4px 16px ${rgba(BLACK, 0.1)};
        text-align: center;
        margin: 15px;

        display: flex;
        flex-direction: column;

        &__dma-icon {
          position: absolute;
          top: 4px;
          right: 4px;
          cursor: pointer;

          &:hover {
            &:before {
              content: attr(data-text);
              position: absolute;
              top: 100%;
              right: -15px;
              z-index: 1;
              width: 150px;
              background-color: ${MAIN_BLACK};
              color: ${WHITE};
              font-weight: 500;
              font-size: 12px;
              line-height: 15px;
              padding: 8px 10px;
              border-radius: 3px;
            }
          }

          img {
            width: 24px;
            height: 24px;
          }
        }

        &__logo {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 80px;
          margin-bottom: 12px;

          img {
            max-width: 100%;
            max-height: 80px;
            width: auto;
          }
        }

        &__main-info {
          height: 100%;
          min-height: 71px;

          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .price__content {
            flex: 1;
          }
        }

        &__button {
          width: 100%;
          max-width: 160px;
          margin: 0 auto;
        }

        .price__content {
          p {
            padding: 0;
          }
        }

        &__deal-price {
          display: flex;
          flex-direction: column;
          align-items: center;

          .service-card__old-cost {
            position: relative;
            line-height: 1.9rem;
            margin-bottom: -2px;
            color: ${SANTAS_GRAY};

            &:before {
              content: '';
              position: absolute;
              right: -3px;
              left: -3px;
              top: 50%;
              transform: translate(0, -50%);
              height: 1px;
              background-color: ${RADICAL_RED};
            }

            strong {
              font-weight: 400;
            }
          }
        }

        &__cost {
          font-size: 1.8rem;
          line-height: 3rem;
          color: ${SANTAS_GRAY};

          strong {
            font-weight: 500;
          }
        }
      }

      .carousel-wrap {
        position: relative;
        overflow: hidden;
        margin: -15px;
      }

      .swiper-carousel {
        padding-bottom: 20px;

        .swiper-pagination-bullets {
          bottom: -5px;

          .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin: 0 4px;
            background-color: ${MAIN_BLACK};
          }
        }
      }

      .app-card {
        position: relative;
        padding: 25px 25px 20px;
        background-color: ${appCard.bg};
        text-align: center;
        transition: all 0.4s;
        box-shadow: 0 8px 16px ${rgba(BLACK, 0.1)};
        border-radius: 16px;
        height: 100%;

        &:hover {
          box-shadow: 0 16px 32px ${rgba(BLACK, 0.1)};
          transform: translateY(-5px);
        }

        p {
          padding: 0;
        }

        &__logo {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 80px;
          margin-bottom: 23px;

          img {
            width: auto;
            max-width: 100%;
            max-height: 80px;
          }
        }

        &__title {
          font-size: 2rem;
          font-weight: 700;
          line-height: 2rem;
          margin-bottom: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &__deal-price {
          display: flex;
          flex-direction: column;
          align-items: center;

          .app-card__cost {
            margin-bottom: 0;
            position: relative;
            &:before {
              content: '';
              position: absolute;
              right: -3px;
              left: -3px;
              top: 50%;
              transform: translate(0, -50%);
              height: 1px;
              background-color: ${RADICAL_RED};
            }
          }
        }

        &__cost {
          display: block;
          font-size: 14px;
          line-height: 14px;
          font-weight: 500;
          text-align: center;
          color: ${appCard.cost};
          margin-bottom: 17px;
        }

        &__deal-cost {
          display: block;
          font-size: 14px;
          line-height: 14px;
          font-weight: bold;
          text-align: center;
          color: ${appCard.cost};
          margin-bottom: 3px;
        }

        &__description {
          padding-top: 25px;
          margin-bottom: 25px;
          height: 85px;
          overflow: hidden;

          ${breakpoints.down('xs')} {
            height: auto;
          }

          p {
            font-size: 14px;
            line-height: 20px;
            font-weight: 500;
          }
        }

        &__button {
          width: 100%;
          max-width: 160px;
          margin: 0 auto;
        }
      }
    }

    // shortcode-app
    .shortcode-app,
    &.shortcode-app {
      display: flex;
      align-items: center;
      cursor: default;

      ${breakpoints.down('sm')} {
        flex-direction: column;
      }

      p {
        padding: 0;
      }

      &__image {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 70px;

        img {
          max-width: 130px;
          max-height: 100%;
          pointer-events: none;
        }

        ${breakpoints.down('lg')} {
          padding: 0 40px;

          img {
            max-width: 90px;
          }
        }

        ${breakpoints.down('sm')} {
          padding: 0 40px 20px;

          img {
            max-width: 130px;
          }
        }
      }

      &__service-content {
        padding-right: 40px;

        ${breakpoints.down('lg')} {
          padding-right: 25px;
        }

        ${breakpoints.down('sm')} {
          padding-right: 0;
        }
      }

      .service-content {
        &__title {
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          ${breakpoints.down('sm')} {
            justify-content: center;
          }
        }

        &__name {
          font-weight: 700;
          color: ${colors.text};
          margin-right: 5px;
          font-size: 2rem;
          line-height: 2.3rem;
        }

        &__cost {
          color: ${colors.textSecondary};
          font-size: 2rem;
          line-height: 2.3rem;
        }

        &__description {
          p {
            font-size: 1.4rem;
            line-height: 2rem;
            text-align: justify;
          }
        }
      }

      &__buttons,
      .buttons {
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 10px 70px;

        ${breakpoints.down('lg')} {
          padding: 5px 40px;
        }

        ${breakpoints.down('sm')} {
          text-align: center;
          margin-left: 0;
        }

        &__container {
          margin-bottom: 15px;

          &:last-of-type {
            margin-bottom: 0;
          }
        }

        &__learn-more {
          a {
            color: ${p => p.theme.palette.text.primary};
            transition: color 0.3s ease;
            cursor: pointer;
            font-size: 1.4rem;
            line-height: 1.6rem;
            white-space: nowrap;
            word-break: break-word;
            text-decoration: none;
            font-weight: 500;
            padding: 2px 4px;

            &:hover {
              color: ${p => p.theme.palette.primary.main};
            }
          }
        }
      }
    }

    // shortcode-channel-services
    .shortcode-channel-services,
    &.shortcode-channel-services {
      margin: 50px 0;

      &__title {
        font-weight: 600;
        font-size: 30px;
        line-height: 42px;
        padding: 0;
        margin-bottom: 20px;
      }
    }

    // typography
    h1,
    h2,
    h3,
    h4,
    h5 {
      margin: 0;
    }

    h1,
    h2 {
      padding: 34px 0 12px;

      ${breakpoints.down('sm')} {
        padding-top: 24px;
      }
    }

    h3,
    h4 {
      padding: 30px 0 3px;

      ${breakpoints.down('sm')} {
        padding-top: 20px;
      }
    }

    h1 {
      font-weight: 600;
    }

    h2 {
      line-height: 4.9rem;
      font-weight: 600;
    }

    h4 {
      line-height: 3.5rem;
      font-weight: 600;
    }

    h5 {
      font-size: 2.4rem;
      line-height: 2.8rem;
      font-weight: 600;
    }

    h6 {
      line-height: 2.1rem;
      font-weight: 600;
    }

    hr {
      margin: 8px 0;
    }

    a {
      color: ${p => p.theme.palette.primary.main};

      word-break: break-word;
      text-decoration: none;
    }

    p {
      margin: 0;
      padding: 10px 0 20px;
      line-height: 3rem;
    }

    .color-primary {
      color: ${p => p.theme.palette.primary.main};
    }

    .color-primary-bg {
      background-color: ${p => p.theme.palette.primary.main};
      color: ${p => p.theme.palette.primary.contrastText};
    }

    .color-secondary-bg {
      background-color: ${p => p.theme.palette.secondary.main};
      color: ${p => p.theme.palette.secondary.contrastText};
    }

    .primary {
      button {
        background-color: ${p => p.theme.palette.primary.main};
        color: ${p => p.theme.palette.primary.contrastText};

        &:hover {
          background-color: ${p => p.theme.palette.primary.main};
          color: ${p => p.theme.palette.primary.contrastText};
        }

        &[class^='vce-button--style-3d'] {
          box-shadow: 0 3px 0 0 ${p => darken(0.1, p.theme.palette.primary.main)};
        }

        &[class^='vce-button--style-animated-outline'] {
          &::before,
          &::after {
            border-color: ${p => p.theme.palette.primary.contrastText};
          }
        }
      }
    }

    a.primary-button {
      background-color: ${p => p.theme.palette.primary.main};
      color: ${p => p.theme.palette.primary.contrastText};
      border: none;
      padding: 1.3rem 2.4rem;
      margin: 0 auto;
      font-weight: 700;

      &:hover {
        background-color: ${p => p.theme.palette.primary.main};
        color: ${p => p.theme.palette.primary.contrastText};
      }
    }

    .secondary {
      button {
        background-color: ${p => p.theme.palette.secondary.main};
        color: ${p => p.theme.palette.secondary.contrastText};

        &:hover {
          background-color: ${p => p.theme.palette.secondary.main};
          color: ${p => p.theme.palette.secondary.contrastText};
        }

        &[class^='vce-button--style-3d'] {
          box-shadow: 0 3px 0 0 ${p => darken(0.1, p.theme.palette.secondary.main)};
        }

        &[class^='vce-button--style-animated-outline'] {
          &::before,
          &::after {
            border-color: ${p => p.theme.palette.secondary.contrastText};
          }
        }
      }
    }

    a.secondary-button {
      background-color: ${p => p.theme.palette.secondary.main};
      color: ${p => p.theme.palette.secondary.contrastText};

      &:hover {
        background-color: ${p => p.theme.palette.secondary.main};
        color: ${p => p.theme.palette.secondary.contrastText};
      }
    }

    .vce-classic-accordion {
      .vce-classic-accordion-panel {
        background-color: ${WHITE};
        margin-bottom: 16px;
        border-radius: 8px;

        &[data-vcv-active] {
          .vce-classic-accordion-panel-title::after {
            content: '\\e90e';
          }
        }
      }

      .vce-classic-accordion-panel-title {
        display: block;
        padding: 32px 60px 32px 40px;
        font-size: 1.8rem;
        line-height: 1.8rem;
        font-weight: 600;
        color: ${p => p.theme.palette.text.primary};

        ${breakpoints.down('xs')} {
          padding: 24px 50px 24px 24px;
        }

        &::after {
          content: '\\e90f';
          font-family: 'icomoon';
          position: absolute;
          top: calc(50% - 9px);
          right: 40px;

          ${breakpoints.down('xs')} {
            right: 24px;
          }
        }
      }

      .vce-classic-accordion-panel,
      .vce-classic-accordion-panel:hover,
      .vce-classic-accordion-panel:hover .vce-classic-accordion-panel-heading,
      .vce-classic-accordion-panel-heading {
        border-color: ${WHITE};
      }

      .vce-classic-accordion-panel-body {
        padding: 0 40px 0;

        ${breakpoints.down('xs')} {
          padding: 0 24px 0;
        }

        p {
          padding: 0;
        }
      }
    }

    .vce-faq-group-shape--rounded {
      .vce-faq-group-item {
        border-radius: 6px;
        border-color: ${WHITE};
      }
    }

    .vce-faq-group {
      .vce-faq-group-item {
        &:not(:last-of-type) {
          margin-bottom: 16px;
        }

        &--opened {
          .vce-faq-group-item-icon {
            transform: rotate(0deg);

            &::after {
              content: '\\e90e';
            }
          }
        }
      }

      .vce-faq-group-item-icon {
        &::before {
          display: none;
        }

        &::after {
          content: '\\e90f';
          font-family: 'icomoon';
          position: absolute;
          right: 40px;
          height: auto;
          width: auto;
          background-color: transparent;
        }
      }

      .vce-faq-group-item-heading {
        padding: 32px 60px 32px 40px;

        ${breakpoints.down('xs')} {
          padding: 24px 50px 24px 24px;
        }

        h3 {
          font-size: 1.8rem;
          line-height: 1.8rem;
          font-weight: 600;
          padding: 0;
        }

        .vce-faq-group-item-heading-title,
        .vce-faq-group-item-icon {
          color: ${p => p.theme.palette.text.primary};
        }
      }

      .vce-faq-group-item-content {
        padding: 0 40px 32px;
        border-color: ${WHITE};

        ${breakpoints.down('xs')} {
          padding: 0 24px 24px;
        }

        p {
          padding: 0;

          + p {
            margin-top: 10px;
          }
        }
      }
    }
  }

  &.auth {
    .auth-dialog {
      display: none;
    }
    .logged-out-content {
      display: none;
    }
  }
`;

export const Disclosure = styled(Typography)`
  cursor: pointer;
  margin-top: 25px;
  font-size: 1.4rem;
  line-height: 1.4rem;
  font-weight: 600;
  display: inline-block;

  svg {
    margin-right: 5px;
    font-size: 1.4rem;
    vertical-align: top;
  }
`;

export default Section;
